import Image from "next/image";
import { useTranslation } from "next-i18next";
import { FunctionComponent } from "react";

import styles from "./ReliabilitySource.module.scss";

import { selectImgReliabilitySources, selectSourceColor, selectSourceText } from "@lib/helper/sourceUtils";
import { SourceReliability } from "@lib/store/models/brandsModels";

interface IReliabilitySourceProps {
  reliability?: SourceReliability;
}

const ReliabilitySource: FunctionComponent<IReliabilitySourceProps> = ({ reliability }) => {
  const { t } = useTranslation("brand");

  if (!reliability) return <></>;

  const source = selectImgReliabilitySources(reliability);
  const text = selectSourceText(reliability);
  const sourceColorStyle = `reliability-source__icon${selectSourceColor(reliability)}`;
  return (
    <div className={styles["reliability-source"]}>
      <div className={`${styles["reliability-source__icon"]} ${styles[sourceColorStyle]}`}>
        <Image
          src={source}
          alt="Icon"
          priority={true}
          fill
          sizes="100vw"
          style={{
            objectFit: "contain",
          }}
        />
      </div>
      <p className={styles["reliability-source__text"]}>{t(text)}</p>
    </div>
  );
};

export default ReliabilitySource;
